module.exports = __webpack_public_path__ + "static/media/iconFacebookFooter.62f2e8f6.svg";